<template>
  <a-drawer title="客户档案" placement="right" :closable="true" :maskClosable="true" :visible="visible" @close="onClose"
    width="90vw" :bodyStyle="{
      background: '#F8f8f8',
      height: 'calc(100% - 55px)',
      padding: '15px',
    }" destroyOnClose>
    <div class="baseinfo" active v-if="!customer.customer_id">
      <a-skeleton avatar :paragraph="{ rows: 2 }" />
    </div>
    <div class="baseinfo" v-else>
      <a-page-header :title="customer2.customer_name" :sub-title="customer2.customer_phone">
        <template slot="tags">
          <a-tag color="blue" v-if="customer2.grade">
            {{ customer2.grade }}级
          </a-tag>
          <a-tag v-if="customer.phonearea">{{ customer.phonearea.province }}
            {{ customer.phonearea.city }}</a-tag>
        </template>
        <template slot="extra" v-if="customer.customer_type === '1'">
          <a-button key="1" icon="edit" @click="addFollow()" v-permission="['admin:followlog:create']">
            添加跟进记录
          </a-button>
          <a-button key="2" icon="retweet" @click="changeManagerClick" v-if="
            (customer.customerRelationship &&
              customer.customerRelationship.manager_type === '1') ||
            !customer.customerRelationship
          " v-permission="['admin:customer:changemanager']">
            变更销售
          </a-button>
          <!-- <a-button key="3" icon="user" @click="changeJoinManagerClick" v-if="
            (customer.customerRelationship &&
              customer.customerRelationship.manager_type === '1') ||
            !customer.customerRelationship
          " v-permission="['admin:customer:changefirstmanager']">
            变更初次邀请信息
          </a-button> -->
          <a-button key="4" icon="cloud-upload" @click="removesea" v-if="
            (customer.customerRelationship &&
              customer.customerRelationship.manager_type === '1') ||
            !customer.customerRelationship
          " type="primary" v-permission="['admin:customer:transfersea']">
            转入公海
          </a-button>
          <a-button type="danger" @click="addShare()">新增共享</a-button>
          <!-- <a-button key="1" type="primary" icon="phone"> 拨打电话 </a-button> -->
        </template>
        <template slot="extra" v-else>
          <a-button key="1" icon="edit" @click="receive()"> 领取客户 </a-button>
        </template>
        <a-row type="flex" :gutter="40">
          <a-col> <b>销售：</b>{{ customer.managerinfo && customer.managerinfo.user.real_name ?
            customer.managerinfo.user.real_name : "无" }} </a-col>
          <a-col>
            <b>共享员工：</b><a-tag v-for="v in customer.managerChildren" :key="v.user_id">{{
              v.user.real_name
              }}</a-tag>
            <a-tag color="red" v-if='customer.managerChildren.length == 0'>未共享</a-tag>
          </a-col>
          <a-col> <b>建档时间：</b>{{ customer.create_time }} </a-col>
          <!-- <a-col>
            <b>初次邀请入会经理：</b>{{ customer.joinuserinfo && customer.joinuserinfo.real_name ?
              customer.joinuserinfo.real_name
              : '无' }}
          </a-col>
          <a-col>
            <b>初次入会时间：</b>{{ customer.first_jointime }}
          </a-col> -->
        </a-row>
      </a-page-header>
    </div>
    <a-spin :indicator="indicator" :spinning="customer.customer_type !== '1'"
      :tip="(customer.customer_type == 2 ? '公海客户' : customer.customer_type == 4 ? '回收站' : '') + '不可编辑，请先领取客户'">
      <div class="content">
        <div class="content-left">
          <div class="content-base">
            <a-tabs v-model="activekey">
              <a-tab-pane key="1" tab="基本信息">
                <a-row :gutter="20">
                  <a-col :span="16">
                    <a-form-model ref="ruleForm" :model="customer" :rules="rules" layout="vertical">
                      <a-row :gutter="20">
                        <a-col span="8">
                          <a-form-model-item label="客户姓名：" prop="customer_name">
                            <a-input v-model="customer.customer_name" placeholder="客户姓名" />
                          </a-form-model-item>
                        </a-col>
                        <a-col span="8">
                          <a-form-model-item label="手机号码：" prop="customer_phone">
                            <a-input v-model="customer.customer_phone" disabled placeholder="手机号码" />
                          </a-form-model-item>
                        </a-col>
                        <a-col span="8">
                          <a-form-model-item label="身份证号码：" prop="id_no">
                            <a-input v-model="customer.id_no" placeholder="身份证号码" />
                          </a-form-model-item>
                        </a-col>
                        <a-col span="8">
                          <a-form-model-item label="性别：" prop="gender">
                            <a-select v-model="customer.gender" placeholder="请选择性别" allowClear>
                              <a-select-option value="1"> 男 </a-select-option>
                              <a-select-option value="2"> 女 </a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>

                        <a-col span="8">
                          <a-form-model-item label="微信号：" prop="wechart_account">
                            <a-input v-model="customer.wechart_account" disabled placeholder="客户微信号" />
                          </a-form-model-item>
                        </a-col>
                        <a-col span="8">
                          <!-- <a-form-model-item label="重要程度：" prop="grade">
                        <a-select v-model="customer.grade" placeholder="请选择重要程度" allowClear>
                          <a-select-option value="A"> A级 </a-select-option>
                          <a-select-option value="B"> B级 </a-select-option>
                          <a-select-option value="C"> C级 </a-select-option>
                          <a-select-option value="D"> D级 </a-select-option>
                        </a-select>
                      </a-form-model-item> -->
                          <a-form-model-item label="签署会员合同" prop="wechart_account">
                            <a-select v-model="customer.contract" placeholder="请选择是否签署会员合同" allowClear>
                              <a-select-option value="1"> 已签署 </a-select-option>
                              <a-select-option value="2"> 未签署 </a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="16">
                          <a-form-model-item label="住址" prop="customer_address">
                            <a-input v-model="customer.customer_address" placeholder="客户住址"></a-input>
                          </a-form-model-item>
                        </a-col>
                        <a-col span="8">
                          <a-form-model-item label="运营人员">
                            <a-select show-search v-model="customer.op_userid" style="width: 100%" placeholder="选择人员"
                              :filter-option="filterOption">
                              <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id"
                                :label="v.real_name">
                                {{ v.real_name }}
                                <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                                  ({{ v.department.department_name }})
                                </span>
                              </a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>
                        <!-- <a-col span="8">
                      <a-form-model-item label="会员级别" prop="vip">
                        <a-select v-model="customer.vip" style="width: 100%" placeholder="请选择" @change="changeVip">
                          <a-select-option v-for="v in vipList" :key="v.vip_name" :value="v.vip_name"
                            :label="v.vip_name">
                            {{ v.vip_name }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col> -->
                        <!-- <a-col span="8">
                      <a-form-model-item label="会员等级" prop="vip_grade">
                        <a-input-number :formatter="value => `V ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                          :parser="value => value.replace(/V\s?|(,*)/g, '')" style="width: 100%"
                          v-model="customer.vip_grade" :min="0" :step="1" placeholder="输入等级" />
                      </a-form-model-item>
                    </a-col> -->
                        <!-- <a-col span="8">
                      <a-form-model-item label="加入会员价格" prop="vip_price">
                        <a-input-number v-model="customer.vip_price" :min="0" :step="0.01" style="width: 100%"
                          placeholder="请输入会员加入时缴费金额" />
                      </a-form-model-item>
                    </a-col> -->
                        <!-- <a-col span="16">
                      <a-form-model-item label="会员权益" prop="vip_benefit">
                        <a-textarea v-model="customer.vip_benefit" placeholder="会员入会给予的权益或福利" :rows="1"></a-textarea>
                      </a-form-model-item>
                    </a-col> -->
                        <a-col span="24">
                          <a-form-model-item label="客户备注：" prop="remark">
                            <a-textarea v-model="customer.remark" placeholder="客户备注" :rows="2" />
                          </a-form-model-item>
                        </a-col>
                      </a-row>
                      <a-form-model-item v-permission="['admin:customer:update']">
                        <a-button type="primary" @click="updateCustomer">
                          保存信息
                        </a-button>
                      </a-form-model-item>
                    </a-form-model>
                  </a-col>
                  <a-col :span="8">
                    <a-page-header>
                      <template slot="title">
                        <h6>会员福利核销</h6>
                      </template>
                      <template slot="extra">
                        <a-button type="link" size="mini" @click="addFuli()">
                          新增会员福利
                        </a-button>
                      </template>
                    </a-page-header>
                    <ul class="list">
                      <li v-for="v in customer.benefitChildren" :key="v.id">
                        <div class="title">{{ v.name }}</div>
                        <div class="subtitle">创建时间：{{ v.create_time }}</div>
                        <div class="subtitle" v-if="v.use_type == 2 && v.used_time">核销时间：{{ v.used_time }}</div>
                        <div class="tool">
                          <a-tag color="green" v-if="v.use_type == 2">已使用</a-tag>
                          <a-tag color="red" v-if="v.use_type == 1">未使用</a-tag>
                          <a-tag type="" style="cursor: pointer;" @click="addFuli(v)"
                            v-if="v.use_type == 1">点击核销</a-tag>
                        </div>
                      </li>
                      <a-empty :image-style="{
                        height: '80px',
                      }" v-if="customer.benefitChildren.length == 0">
                        <span slot="description">
                          暂无 <a href="#API">会员福利数据</a>
                        </span>
                      </a-empty>
                    </ul>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" tab="会员合同">
                <queryCustomerContract ref="queryCustomerContract" :customer_id="customer_id"></queryCustomerContract>
              </a-tab-pane>
              <a-tab-pane key="3" tab="会员信息">
                <member ref="member" :customer_id="customer_id"></member>
              </a-tab-pane>
              <a-tab-pane key="4" tab="制定行程">
                <tripTool ref="tripTool" :customer_id="customer_id" @changeNewCustomerid="changeNewCustomerid">
                </tripTool>
              </a-tab-pane>
              <a-tab-pane key="5" tab="行程档案（做单）">
                <Trip :customer_id="customer_id"></Trip>
              </a-tab-pane>
              <a-tab-pane key="6" tab="港澳台登记信息">
                <Idinfo :customer_id="customer_id"></Idinfo>
              </a-tab-pane>
              <a-tab-pane key="8" tab="客户号码申请查看">
                <CPhoneApplication :customer_id="customer_id"></CPhoneApplication>
              </a-tab-pane>
              <a-tab-pane key="7" tab="隐私通话">
                <PrivacyCall :customer_id="customer_id"></PrivacyCall>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div class="content-right">
          <div class="content-base">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="跟进记录"> </a-tab-pane>
              <!-- <a-tab-pane key="2" tab="基本信息"></a-tab-pane> -->
            </a-tabs>
            <div class="tabContent">
              <a-comment v-for="v in customer.followlogs" :key="v.followlog_id">
                <a slot="author">{{ v.user.real_name || v.user.username }}</a>
                <a-avatar slot="avatar" :style="{ backgroundColor: '#00a2ae', verticalAlign: 'middle' }" alt="Han Solo">
                  {{ v.user.real_name || v.user.username }}
                </a-avatar>
                <p slot="content">
                  {{ v.followlog_content }}
                </p>
                <a-tooltip slot="datetime">
                  {{ v.followlog_createtime }}
                </a-tooltip>
              </a-comment>
              <a-empty style="height: 200px" :image-style="{
                height: '80px',
              }" v-if="customer.followlogs.length == 0">
                <span slot="description">
                  暂无 <a href="#API">跟进记录</a>
                </span>
                <a-button type="primary" @click="addFollow" v-permission="['admin:followlog:create']"> 立即添加 </a-button>
              </a-empty>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <Follow ref="follow" @followok="getInfo"></Follow>
    <ChangeManager ref="changeManager" @ok="changeManagerOk"></ChangeManager>
    <ChangeJoinManager ref="changeJoinManager" @ok="changeManagerOk"></ChangeJoinManager>
    <AddCustomerShare ref="addCustomerShare" @ok="getInfo"></AddCustomerShare>
    <addbenefit ref="addbenefit" @ok="getInfo"></addbenefit>
  </a-drawer>
</template>

<script>
import Follow from "@/components/Follow/index.vue";
import ChangeManager from "@/components/ChangeManager/index.vue";
import ChangeJoinManager from "@/components/ChangeJoinManager/index.vue";
import Trip from "../../views/trip/index.vue";
import Idinfo from "../../views/trip/idinfo.vue";
import tripTool from "../../views/trip/tripTool.vue";
import AddCustomerShare from "@/components/AddCustomerShare/index.vue";
import member from "./member.vue";
import addbenefit from "./components/addbenefit.vue";
import PrivacyCall from "@/components/PrivacyCall/index.vue";
import CPhoneApplication from "./CPhoneApplication.vue";
import queryCustomerContract from "./queryCustomerContract.vue";
export default {
  components: {
    Follow,
    ChangeManager,
    ChangeJoinManager,
    Trip,
    Idinfo,
    tripTool,
    AddCustomerShare,
    member,
    addbenefit,
    PrivacyCall,
    CPhoneApplication,
    queryCustomerContract
  },
  data() {
    return {
      visible: false,
      activekey: '1',
      customer_id: "",
      customer: {
        customer_id: "",
        followlogs: [],
        grade: undefined,
        benefitChildren: []
      },
      customer2: {},
      rules: {
        customer_name: [
          {
            required: true,
            message: "客户姓名必填",
            trigger: "blur",
          },
        ],
        customer_phone: [
          {
            required: true,
            message: "客户手机号必填",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
      vipList: [],
      userList: []
    };
  },
  methods: {
    init(op) {
      this.customer_id = op.customer_id;
      this.$nextTick(() => {
        this.visible = true;
        this.getInfo();
        this.getUserList()
        this.getVipList()
        this.$emit("newCustomerid", op.customer_id)
      })
    },
    addFuli(info) {
      this.$refs.addbenefit.init({
        customer_id: this.customer_id,
        info
      })
    },
    //新增共享
    addShare() {
      this.$refs.addCustomerShare.init([this.customer]);
    },
    resetlist() {
      if (this.activekey == 2) {
        this.$refs.tripTool.query()
      }
    },
    changeNewCustomerid(id) {
      this.$emit("newCustomerid", id)
      this.visible = false
    },
    indicator(h) {
      return null;
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    getVipList() {
      this.$http({
        url: "/admin/viplist/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.vipList = res.data.result;
      });
    },
    changeVip(e) {
      // const a = this.vipList.find(v => v.vip_name == e)
      // this.customer.vip_price = a.vip_price
      // this.customer.vip_benefit = a.benefit
    },
    getInfo() {
      this.$http({
        url: "/admin/customer/info",
        method: "post",
        data: {
          id: this.customer_id,
        },
      }).then((res) => {
        this.customer = {
          ...res.data,
          // vip: res.data.vip == null ? undefined : res.data.vip,
          op_userid: res.data.op_userid == null ? undefined : res.data.op_userid,
          contract: res.data.contract == null ? undefined : res.data.contract
        };
        this.customer2 = res.data
      });
    },
    onClose() {
      this.visible = false;
      this.activekey = '1'
      this.changeNewCustomerid("")
    },
    addFollow() {
      this.$refs.follow.init(this.customer_id);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    updateCustomer() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$http({
            url: "/admin/customer/update",
            method: "post",
            data: this.customer,
          }).then(() => {
            this.$message.success("修改客户成功");
            this.getInfo();
            this.$emit("ok");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //转入公海
    removesea() {
      this.$confirm({
        title: "是否将当前客户转入到公海中?",
        content: (h) => (
          <div style="color:red;">
            转入后该客户将不在“我的客户”中可见，已共享员工也将失效
          </div>
        ),
        onOk: () => {
          this.$http({
            url: "/admin/customer/transfersea",
            method: "post",
            data: {
              customer_ids: [this.customer.customer_id],
            },
          }).then((res) => {
            this.$message.success("转入公海成功");
            this.onClose();
            this.$emit("ok");
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    //领取客户
    receive() {
      this.$confirm({
        title: "是否领取该客户?",
        content: (h) => (
          <div style="color:red;">领取后此客户将进入“我的客户”中</div>
        ),
        onOk: () => {
          this.$http({
            url: "/admin/customer/getcustomer",
            method: "post",
            data: {
              customer_ids: [this.customer.customer_id],
            },
          }).then((res) => {
            this.$message.success("领取成功");
            this.onClose();
            this.$emit("ok");
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    //变更销售
    changeManagerClick() {
      this.$refs.changeManager.init(
        this.customer_id,
        this.customer.managerinfo.user_id
      );
    },
    changeJoinManagerClick() {
      this.$refs.changeJoinManager.init(
        this.customer_id
      );
    },
    changeManagerOk() {
      this.visible = false;
      this.$emit("ok");
    },
  },
};
</script>

<style socped lang="scss">
.baseinfo {
  background: #fff;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.content {
  height: calc(100% - 145px - 15px);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .content-left,
  .content-right {
    height: 100%;
  }

  .content-left {
    width: calc(75% - 15px);
  }

  .content-right {
    width: 25%;
  }
}

.content-base {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow: auto;

  .tabContent {
    // border: 1px solid red;
    // height: 580px;
    // width: 100%;
    overflow-y: auto;
    // height: auto;
    height: calc(100% - 60px);
  }
}

.list {
  li {
    margin-bottom: 20px;

    .title {
      margin-bottom: 5px;
      color: #000;
    }

    .subtitle {
      color: #888;
      font-size: 13px;
    }

    .tool {
      margin-top: 5px;
    }
  }

}
</style>